<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-purple-50 to-pink-100 animate-gradient-x">
    <div v-loading="loading"
         class="bg-white/90 backdrop-blur-sm p-6 rounded-2xl shadow-2xl w-full max-w-md transform transition-all duration-300 hover:scale-105 hover:shadow-indigo-200">
      <!-- 左上角标志 -->
      <div class="mb-6 text-center transform transition-all duration-500 hover:scale-110">
        <img @click="tohome()" alt="IP奇迹ip Logo" class="h-16 mx-auto cursor-pointer" src="@/assets/logB.png"/>
      </div>
      <!-- 标题 -->
      <h2 class="text-3xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-indigo-600 mb-6 text-center">
        修改密码
      </h2>
      <!-- 邮箱输入框 -->
      <div class="mb-4">
        <div class="relative group">
          <i class="fas fa-envelope absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-indigo-500 transition-colors duration-200">
          </i>
          <input
              class="w-full pl-12 pr-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all duration-200 bg-white/50 backdrop-blur-sm"
              type="email"
              :maxlength="100"
              v-model.trim="form.email"
              placeholder="请输入邮箱"/>
        </div>
      </div>
      <!-- 旧密码输入框 -->
      <div class="mb-4">
        <div class="relative group">
          <i class="fas fa-lock absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-indigo-500 transition-colors duration-200">
          </i>
          <input
              class="w-full pl-12 pr-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all duration-200 bg-white/50 backdrop-blur-sm"
              type="password"
              :maxlength="50"
              v-model.trim="form.password"
              placeholder="请输入旧密码"/>
        </div>
      </div>
      <!-- 新密码输入框 -->
      <div class="mb-4">
        <div class="relative group">
          <i class="fas fa-key absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-indigo-500 transition-colors duration-200">
          </i>
          <input
              class="w-full pl-12 pr-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all duration-200 bg-white/50 backdrop-blur-sm"
              type="password"
              :maxlength="50"
              v-model.trim="form.new_password"
              placeholder="请输入新密码"/>
        </div>
      </div>
      <!-- 确认新密码输入框 -->
      <div class="mb-6">
        <div class="relative group">
          <i class="fas fa-key absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-indigo-500 transition-colors duration-200">
          </i>
          <input
              class="w-full pl-12 pr-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all duration-200 bg-white/50 backdrop-blur-sm"
              type="password"
              :maxlength="50"
              v-model.trim="form.new_password_confirm"
              placeholder="请再次输入新密码"/>
        </div>
      </div>
      <!-- 修改按钮 -->
      <button
          class="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-3 px-6 rounded-xl hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-indigo-300 shadow-lg transform transition-all duration-300 hover:scale-102 hover:shadow-indigo-200 font-semibold"
          @click="codeupdetd('form')">
        <i class="fas fa-key mr-2 animate-pulse">
        </i>
        确认修改
      </button>
    </div>

  </div>
</template>

<script>
import api from "@/requset/api";

export default {
  name: 'PasswordUpdate',
  data() {
    return {
      loading: false,
      checked: "",
      valueL: "",
      radio: "1",
      datauser: {
        name: "",
        smsCode: "",
      },
      huakuai: "",
      show: true,
      count: 60,
      form: {
        captcha: "",
        email: "",
        mobile: "",
        password: "",
        new_password: "",
        new_password_confirm: ""
      },
      codeRules: {
        phone: [{required: true, message: "请输入手机号", trigger: "blur"}],
        paswd: [{required: true, message: "请输入密码", trigger: "blur"}],
        smsCode: [
          {required: true, message: "请输入手机验证码", trigger: "blur"},
        ],

        checkMove: [
          {required: true, message: "滑动完成验证", trigger: "blur"},
        ],
      },
    };
  },
  components: {},
  directives: {},

  mounted() {
  },
  methods: {
    codeupdetd() {
      if (this.form.new_password !== this.form.new_password_confirm) {
        this.$message({
          message: "2次新密码不一致",
          type: "warning",
        });
      } else if (this.form.email.length == 0) {
        this.$message({
          message: "必须输入邮箱",
          type: "warning",
        });
      } else if (this.form.password.length == 0) {
        this.$message({
          message: "必须输入旧密码",
          type: "warning",
        });
      } else if (this.form.new_password.length == 0) {
        this.$message({
          message: "必须输入新密码",
          type: "warning",
        });
      } else {
        this.loading = true
        api.update_password({
          email: this.form.email,
          password: this.form.password,
          captcha: this.form.smsCode,
          new_password: this.form.new_password,
        })
            .finally(() => {
              this.loading = false
            })
            .then((res) => {
              if (res.data.error_code == 0) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.$cookies.remove("userdata");
                this.$router.push({path: "login"});
              } else {
                this.$message({
                  message: res.data.message,
                  type: "warning",
                });
              }
            })
            .catch((err) => {
              console.log(err, "失败");
            });
      }
    },
    tohome() {
      this.$router.push({path: "/"});
    },
    tologin() {
      this.$router.push({path: "login"});
    },
  },
};
</script>
